module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-48.09ec0d1a.png";